<template>
	<div class="emoji-panel" v-show="visible">
		<div class="emoji-grid">
			<span v-for="(emoji, index) in emojis" :key="index" class="emoji-item" @click.stop="selectEmoji(emoji)">
				{{ emoji }}
			</span>
		</div>

		<div class="emoji-footer">
			<button class="close-btn" @click="hidePanel">关闭</button>
		</div>
	</div>
</template>

<script>
	export default {
		name: "EmojiPicker",
		props: {
			visible: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				emojis: [
					"😀", "😃", "😄", "😁", "😆", "😅", "😂", "🤣",
					"😊", "😇", "🙂", "🙃", "😉", "😌", "😍", "🥰",
					"😘", "😗", "😙", "😚", "🤪", "🤨", "🧐", "🤓",
					"😎", "🥳", "😤", "😠", "😡", "🤯", "😳", "🥺",
					"😭", "😢", "😥", "😓", "😞", "😔", "😟", "😕",
					"🙁", "☹️", "😣", "😖", "😫", "😩", "😱", "😨",
					"😰", "😥", "😓", "🤗", "🤝", "🙏", "👍", "👎",
					"👋", "✋", "🤚", "🖐", "🤙", "🤘", "🤟", "💪",
					"👀", "👂", "👃", "👄", "👅", "🧠", "❤️", "💔",
					"💖", "💗", "💓", "💞", "💘", "💝", "😜", "🤪",
					"😝", "😛", "😏", "🤤", "🤫", "🤭"
				]
			};
		},
		methods: {
			selectEmoji(emoji) {
				this.$emit("select", emoji);
			},
			hidePanel() {
				this.$emit("update:visible", false);
			}
		}
	};
</script>

<style scoped>
	.emoji-panel {
		position: absolute;
		bottom: .25rem;
		left: 0;
		width: 5.2rem;
		background: #fff;
		border-radius: .08rem;
		border: .01rem solid #eee;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
		padding: .06rem;
		z-index: 1;
	}

	.emoji-grid {
		display: flex;
		flex-wrap: wrap;
	}

	.emoji-item {
		font-size: .2rem;
		padding: .06rem;
		cursor: pointer;
		transition: transform 0.15s;
		width: 8.33%;
		/* 每行 8 个 */
		text-align: center;
	}

	.emoji-item:hover {
		transform: scale(1.2);
	}

	.emoji-footer {
		text-align: right;
		margin-top: .1rem;
	}

	.close-btn {
		border: none;
		background: #f0f0f0;
		padding: .04rem .12rem;
		border-radius: .04rem;
		font-size: .14rem;
		cursor: pointer;
	}
</style>